var React = require('react');

function Succes (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_69150","data-name":"Group 69150","transform":"translate(-390 -290)"},[React.createElement("g",{"id":"Ellipse_170","data-name":"Ellipse 170","transform":"translate(390 290)","fill":"#12a10d","stroke":"#12a10d","strokeWidth":"1","key":0},[React.createElement("circle",{"cx":"25","cy":"25","r":"25","stroke":"none","key":0}),React.createElement("circle",{"cx":"25","cy":"25","r":"24.5","fill":"none","key":1})]),React.createElement("path",{"id":"Icon_material-done","data-name":"Icon material-done","d":"M13.5,24.3,7.2,18,5.1,20.1l8.4,8.4,18-18L29.4,8.4Z","transform":"translate(396.7 297.55)","fill":"#fff","key":1})]));
}

Succes.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = Succes;

Succes.default = Succes;
